import axios from 'axios'
// import qs from 'qs'
import { Message, Spin} from 'view-ui-plus';
import { router } from '@/router'
import { store } from '@/store/store'

/**
 功能：创建 axios
 time: 2025-37-01 10:37:41
 **/
const axiosIns = axios.create()
if (process.env.NODE_ENV === 'development') { //本地环境
	axiosIns.defaults.baseURL = 'http://www.guolang.com/';
} else if (process.env.NODE_ENV === 'debug') { //调试环境
	axiosIns.defaults.baseURL = 'http://192.168.2.88:8001/';
} else if (process.env.NODE_ENV === 'production') { // 线上环境
	axiosIns.defaults.baseURL = 'https://api.ahguolang.com/'; //线上
}
axiosIns.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axiosIns.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.responseType = 'json';
axiosIns.defaults.timeout = 600000
axiosIns.defaults.validateStatus = ()=> {
	return true;
};
//待判定VUE3中要不要删除
// axiosIns.defaults.transformRequest = [
// 	function (data) {
// 		return qs.stringify(data);
// 	}
// ];
//待判定VUE3中要不要删除
// axiosIns.defaults.validateStatus = function () {
// 	return true;
// };
/**
 功能：添加请求拦截器
 time: 2025-37-01 10:37:11
 **/
axiosIns.interceptors.request.use( config => {
	let token = store.state.token;
	if (token && token !== 'undefined') config.headers['token'] = token
	return config
}, error => {
	Message.error({ background: true, content: 'request error' });
	return Promise.reject(error)
})

/**
 功能：响应拦截器
 time: 2025-37-01 10:37:24
 **/
axiosIns.interceptors.response.use((response) => {
    const res = response.data;
    Spin.hide()
    store.commit('SET_LOADING' , false);
    //当后端返回的自定义状态码表示成功时，返回响应数据
    if (res.code === 100) {
        return response
    }


    // 判定是否需要重新登录
    if (res.code === -2) {
        // Message.error({ background: true, content: '账户验证失败，请重新登录' });
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('userinfo');
        window.localStorage.removeItem('menu_id');
        store.commit('SET_TOKEN' , '');
        store.commit('SET_USERINFO' , []);
        store.commit('SET_MENU_ID' , '');
        router.push({
            path: "/login"
        });
    }
    // 判定是否退出
    if (res.code === -3) {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('userinfo');
        window.localStorage.removeItem('menu_id');
        store.commit('SET_TOKEN' , '');
        store.commit('SET_USERINFO' , []);
        store.commit('SET_MENU_ID' , '');
        router.push({
            path: "/login"
        });
    }


    // 返回一个被拒绝的 Promise，业务代码将进入 catch 块
    return Promise.reject(new Error(res.msg || 'request error'));
}, (error) => {
    Message.error({ background: true, content: error.message || 'network error'});
	return Promise.reject(error)
})


const ajaxMethod = ['get', 'post']
const api = {}
ajaxMethod.forEach((method) => {
	api[method] = (uri, data, config)=> {
		return new Promise(resolve => {
			axiosIns[method](uri, data, config).then((response) => {
                resolve(response.data)
			}).catch(error => {
                Message.error({ background: true, content: error.message ? error.message : 'request error' });
			})
		})
	}
})
export default api
